import type storeId from "./id";

const storeEn: typeof storeId = {
	store: {
		title: "Store",
		subtitle: "Store list summary",
		table_title: "Store Data",
		empty_title: "No store data",
		empty_description: "Please add a new store.",
		detail: {
			back: "Back",
			info_title: "Store Information",
			not_found: "Store not found.",
			tabs: {
				qr: "Payment QR",
				hours: "Operating Hours",
			},
		},
		qr: {
			title: "Payment QR",
			add: "Add QR",
			code: "Code",
			code_placeholder: "Leave empty to generate automatically",
			created_at: "Created At",
			download: "Download QR",
			empty_state: {
				title: "No payment QR yet",
				description: "Add a QR so customers can pay by scanning.",
			},
			add_success: "Payment QR created",
		},
		hours: {
			title: "Operating Hours",
			enable: "Enable operating hours",
			different_daily: "Different hours per day",
			open: "Open",
			close: "Close",
			holiday: "Closed",
			save: "Save",
			success: "Operating hours saved",
			timezone_note:
				"Hours are stored in UTC and shown in your device time zone.",
			days: {
				monday: "Monday",
				tuesday: "Tuesday",
				wednesday: "Wednesday",
				thursday: "Thursday",
				friday: "Friday",
				saturday: "Saturday",
				sunday: "Sunday",
			},
		},
		columns: {
			created_at: "Created At",
			name: "Store Name",
			category: "Category",
			address: "Address",
			phone: "Phone Number",
			pic: "PIC",
			pic_phone: "PIC Phone Number",
			status: "Status",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		add: {
			button: "Add Store",
			title: "Add Store",
			description: "Add new store data",
			success: "Success!",
			success_description: "{name} has been added!",
			error: "An error occurred!",
			error_description: "Please try again later!",
		},
		edit: {
			title: "Edit Store",
			section_info: "Store Information",
			section_pic: "PIC Information",
			section_settings: "Store Settings",
			section_rounding: "Rounding Settings",
			section_footer_printer: "Footer Printer",
			saving: "Saving...",
			save: "Save Changes",
		},
		delete: {
			title: "Delete Store",
			confirm: "Are you sure you want to delete {name}?",
			button: "Delete",
		},
		form: {
			name: "Store Name",
			phone: "Phone Number",
			address: "Address",
			pic_name: "PIC Name",
			pic_phone: "PIC Phone Number",
			category: "Category",
			category_placeholder: "Select Category",
			category_loading: "Loading...",
			category_empty: "No store category data",
			is_retail: "Retail Store",
			is_retail_question: "Retail store?",
			enable_ppob: "Enable PPOB",
			enable_ppob_question: "Enable PPOB?",
			enable_daily_limit: "Enable Daily Limit",
			enable_daily_limit_question: "Enable Daily Limit?",
			enable_card_redeem: "Enable Card Redeem",
			enable_card_redeem_question: "Enable Card Redeem?",
			round_type: "Round Type",
			round_type_placeholder: "Select Round Type",
			round_order: "Round Order",
			footer_printer: "Footer Printer",
			footer_printer_placeholder: "Footer Printer {index}",
			add_footer: "Add Footer Printer",
			remove: "Remove",
		},
		actions: {
			cancel: "Cancel",
			save: "Save",
		},
	},
};

export default storeEn;
